import React, { useState } from "react";
import API from '../../Services/BaseService';

const SellerDeleteAccountForm = () => {
  const [email, setEmail] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!confirmDelete) {
      alert("Please confirm account deletion before submitting.");
      return;
    }

    try {
      setLoading(true);
      const response = await API.post(
        "sellerDeleteAdd/add",
        { email: email.trim() }
      );

      const data = response?.data;

      if (data?.success) {
        alert("Account deletion request submitted. Please check your email.");
        setEmail("");
        setConfirmDelete(false);
      } else {
        alert(data?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Unable to process request. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ paddingTop: "10px" }}>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm fixed-top">
        <div className="container">
          <a
            className="navbar-brand d-flex align-items-center"
            href="https://dev-buyer.ur2ndlot.com/"
          >
            <img
              src="https://buyer.ur2ndlot.com/images/Logo_final.png"
              alt="Ur2ndlot Logo"
              className="img-fluid logo_img"
              style={{ padding: "10px 0px", margin: 0, maxHeight: "100px" }}
            />
          </a>
        </div>
      </nav>

      <div className="container policy-section mt-5 py-3">
        <h1
          className="text-center mb-4 mt-3"
          style={{ color: "#CB3B58" }}
        >
          Delete Account Request
        </h1>

        <p className="mb-4">
          If you wish to permanently delete your Ur2ndlot account, you may
          submit an account deletion request through the official deletion
          request form below. Once your request is submitted, our support
          team will review and process it in accordance with platform
          policies, verification requirements, and applicable legal
          obligations.
        </p>

        <h2 style={{ color: "#002768" }}>1. Information Required</h2>
        <p>
          To process your deletion request, you may be required to provide
          certain account-related information for verification purposes,
          including:
        </p>
        <ul>
          <li>The registered email address linked to your Ur2ndlot account.</li>
          <li>Your registered mobile number, if applicable.</li>
          <li>
            Confirmation that you wish to permanently delete your account and
            associated account-related data.
          </li>
        </ul>

        <h2 style={{ color: "#002768" }}>2. Submission Process</h2>
        <p>
          Once the required information is submitted through the deletion
          request form, the request details will be forwarded to the
          official Ur2ndlot support team for review and processing.
        </p>
        <p>
          Account deletion requests and related communications may be
          handled through:
        </p>
        <p>
          <strong>info@ur2ndlot.com</strong>
        </p>

        <h2 style={{ color: "#002768" }}>3. Confirmation of Request</h2>
        <p>
          After successfully submitting the request, users will receive a
          confirmation message indicating that the deletion request has been
          received and is under review.
        </p>
        <p>Typical confirmation message:</p>
        <div
          className="important-note"
          style={{
            backgroundColor: "#fff3cd",
            borderLeft: "5px solid #ffc107",
            padding: "1rem",
            margin: "1rem 0",
            borderRadius: "5px",
          }}
        >
          "Your request has been received. We'll process it within 7 working
          days."
        </div>

        <h2 style={{ color: "#002768" }}>4. Processing Timeline</h2>
        <p>
          Ur2ndlot will make reasonable efforts to review and process valid
          account deletion requests within approximately seven (7) working
          days. Certain requests may require additional review time in cases
          involving verification checks, disputes, fraud prevention reviews,
          legal obligations, or operational investigations.
        </p>

        <h2 style={{ color: "#002768" }}>5. Effects of Account Deletion</h2>
        <p>Once account deletion is completed, users will permanently lose access to:</p>
        <ul>
          <li>Listing and order history</li>
          <li>Saved items, favorites, and cart data</li>
          <li>Saved addresses and account preferences</li>
          <li>Rewards, subscriptions, and promotional benefits</li>
          <li>Support history and account-related information</li>
        </ul>

        <h2 style={{ color: "#002768" }}>6. Data Retention</h2>
        <p>
          Certain information may continue to be retained where necessary for
          legal compliance, fraud prevention, dispute resolution, tax
          requirements, audit obligations, platform security, safety
          investigations, or other lawful business purposes permitted under
          applicable law.
        </p>

        <h2 style={{ color: "#002768" }}>7. Contact Information</h2>
        <p>For deletion requests, support, or account-related concerns, contact:</p>
        <p>
          Email: <strong>info@ur2ndlot.com</strong>
        </p>
        <p>
          Website:{" "}
          <strong>
            <a href="https://ur2ndlot.com/" target="_blank" rel="noreferrer">
              ur2ndlot.com
            </a>
          </strong>
        </p>
      </div>

      <section className="py-5" id="support" style={{ background: "#F6F6F6" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 mt-2 mt-lg-0">
              <h2 className="mb-4 text-start" style={{ color: "#002768" }}>
                Account Closure Form
              </h2>
              <div className="p-4 shadow rounded-4 bg-white h-100 form-box">
                <form
                  onSubmit={handleSubmit}
                  className="d-flex flex-column h-100"
                >
                  <div className="row g-3 flex-grow-1">
                    <div className="col-md-6 d-flex">
                      <input
                        type="email"
                        className="form-control flex-fill"
                        name="email"
                        placeholder="Enter registered Email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="confirmDelete"
                          name="confirm_delete"
                          checked={confirmDelete}
                          onChange={(e) => setConfirmDelete(e.target.checked)}
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="confirmDelete"
                        >
                          I confirm that I want to delete my account and all
                          associated data.
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <button
                      type="submit"
                      className="message-btn"
                      disabled={loading}
                      style={{
                        background: "#cb3b58",
                        border: 0,
                        padding: "10px 24px",
                        color: "#fff",
                        transition: "0.4s",
                        borderRadius: "4px",
                      }}
                    >
                      {loading ? "Sending..." : "Send Message"}{" "}
                      <i className="bi bi-arrow-right ms-2"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SellerDeleteAccountForm;